import React from 'react';
import { ONBOARDING_VOUCHER_RECEIVED_QUESTION } from '../../../constants/Copy';
import Button, { BUTTON_KIND_TEXT } from '../buttons/onboarding/OnboardingButton';
import { ROUTE_ACTIVATE_VOUCHER } from '../../../constants/Routes';
import history from '../../../history';

function VoucherLinkComponent({ testId }) {
	return (
		<Button
			className="onboarding__link"
			kind={BUTTON_KIND_TEXT}
			onClick={() => history.push(ROUTE_ACTIVATE_VOUCHER)}
			testId={testId}
		>
			{ONBOARDING_VOUCHER_RECEIVED_QUESTION}
		</Button>
	);
}

export default VoucherLinkComponent;
